<template>
    <div class="ilightbox">
        <div class="ilightbox-toolbar black">
            <a
                class="ilightbox-close"
                title="Press Esc to close"
                @click.prevent="close"
            ></a>
        </div>
        <div class="ilightbox-overlay black" @click="close"></div>
        <div class="ilightbox-loader black horizontal">
            <div></div>
        </div>
        <div class="ilightbox-holder black">
            <div class="ilightbox-container">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped lang="scss">
.ilightbox {
    display: flex;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;

    .ilightbox-toolbar {
        display: block;
    }

    .ilightbox-overlay {
        opacity: 0.94;
        display: block;
    }

    .ilightbox-loader {
        left: 965px;
        opacity: 1;
    }

    .ilightbox-holder {
        display: block;
        width: 80%;
    }
}
</style>
